import React, { useState, useEffect } from 'react';
import "./Feed.css";
import StoryReel from "./StoryReel";
import MessageSender from './MessageSender';
import Post from "./Post";
import db from "./firebase";

function Feed() {

    // to pull posts from firestore
    const [posts, setPosts] = useState([]);

    // to run it once
    useEffect(() => {
        db.collection("posts")
            .orderBy('timestamp', 'desc')
            .onSnapshot((snapshot) =>
                // pull data when collectionchanges - snapshot realtime
                setPosts(snapshot.docs.map((doc) => ({ id: doc.id, data: doc.data() })))
            );
    }, [])

    return (
        <div className="feed">


            {/* Story Row */}
            <StoryReel />

            {/* Message Sender */}
            <MessageSender />

            {/* {Posts section} */}

            {posts.map((post) => (
                <Post
                    keys={post.id}
                    profilePic={post.data.profilePic}
                    message={post.data.message}
                    timestamp={post.data.timestamp}
                    username={post.data.username}
                    image={post.data.image}

                />
            ))}

        </div>
    );
}

export default Feed;